import React, { Fragment } from 'react';
import { Dialog } from './../../common/dialog';
import { useDropzone } from 'react-dropzone';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import moment from 'moment';
import { empty } from './../../../utils';

const HelpModal = React.memo((props) => {
    const {
        // acceptedFiles,
        // fileRejections,
        getRootProps,
        getInputProps
    } = useDropzone({
        multiple: true,
        onDrop: (files) => {
            for (let i = 0; i < files.length; i++) {
                props.addFile(files[i]);
            }
        }
    });

    const hideHandler = () => {
        props.clearFiles();
        props.resetFields();
        props.hideHelpModal();
    };

    const sendHandler = () => {
        props.sendRequest();
    };

    const handleChangeHandler = (field, event) => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        props.setField(field, value);
    };

    let label = 'Send';
    if (props.isSending) {
        label = <i className="fas fa-circle-notch fa-spin" />;
    }

    const teamType = parseInt(props.fields.team_type);

    const renderFiles = () => {
        if (props.files.length === 0) {
            return (
                <tr>
                    <td colSpan="2">No files selected</td>
                </tr>
            );
        }

        return props.files.map((file, index) => {
            let actionIcon = (
                <Tooltip title="Remove File" position="bottom" arrow size="small" className="action-tooltip">
                    <i className="fas fa-trash" onClick={props.removeFile.bind(this, index)} />
                </Tooltip>
            );
            if (props.id) {
                actionIcon = (
                    <Tooltip title="Download File" position="bottom" arrow size="small" className="action-tooltip">
                        <a href={file.url} target="_blank" rel="noopener noreferrer"><i className="fas fa-download" /></a>
                    </Tooltip>
                );
            }

            return (
                <tr>
                    <td>{file.name}</td>
                    <td className="text-center actions">
                        {actionIcon}
                    </td>
                </tr>
            );
        });
    };

    let fittingMessage = '';
    let fittingContainer = null;
    if (props.fields.help_with_fitting) {
        fittingMessage = <span className="fitting-message">Describe the style and provide size you need to try on.</span>;

        let now = moment();
        const months = [];
        const days = [];

        for (let i = 0; i < 9; i++) {
            months.push(<option value={now.format('YYYY') + '-' + now.format('MM')}>{now.format('MMMM')}</option>);
            now.add(1, 'months');
        }

        now = moment();
        let tomorrow = moment(now.format('YYYY-MM-DD')).add(1, 'days');

        if (!empty(props.fittingMonth)) {
            let date = moment(props.fittingMonth + '-01');
            let j = 0;
            let monthNumber = parseInt(date.format('M'));
            while (parseInt(date.format('M')) === monthNumber && j < 100) {
                if (parseInt(date.format('d')) === 2) {
                    let disabled10 = date.diff(tomorrow, 'days') <= 4;

                    for (let i = 0; i < props.fittingReserved.length; i++) {
                        const reserved = props.fittingReserved[i];
                        const reservedDate = moment(reserved['year'] + '-' + reserved['month'] + '-' + reserved['day']);
                        if (date.diff(reservedDate, 'days') === 0) {
                            if (parseInt(reserved['hour']) === 10) {
                                disabled10 = true;
                            }
                        }
                    }

                    let disabled10Label = '';
                    if (disabled10) {
                        disabled10Label = ' - Not Available'
                    }

                    days.push(
                        <option value={date.format('D') + '-10'} disabled={disabled10}>
                            {date.format('dddd')} ({date.format('MM/DD/YYYY')}) @ 10:00 am{disabled10Label}
                        </option>
                    );
                }

                date.add(1, 'days');
                j++;
            }
        }

        const handleChangeMonth = (event) => {
            props.setFittingMonth(event.target.value);
            props.checkFittingMonth();
        };

        let fittingLocationFieldsDisabled = false;
        let fittingLocationRequiredAsterisk = <span className="required">*</span>;
        if (props.fields.fitting_how_many_people < 5) {
            fittingLocationFieldsDisabled = true;
            fittingLocationRequiredAsterisk = null;
        }

        fittingContainer = (
            <Fragment>
                <hr />
                <div className="fitting-container">
                    <div><b>Fittings are schedule for Tuesday each week.</b></div>
                    <div className="date-fields">
                        <div className="month-field">
                            Selection Date <span className="required">*</span>:
                            <select value={props.fittingMonth} onChange={handleChangeMonth}>
                                <option value="">Select option</option>
                                {months}
                            </select>
                        </div>
                        <div className="day-field">
                            Date/Time <span className="required">*</span>:
                            <select value={props.fittingDate} onChange={(event) => props.setFittingDate(event.target.value)}>
                                <option value="">Select option</option>
                                {days}
                            </select>
                            <br />
                            <div className="date-message">* Schedule must be made 72 hours in advance.</div>
                        </div>
                    </div>
                    <div className="fitting-information">
                        <div className="how-many-field">
                            How many people? <span className="required">*</span>
                            <select value={props.fields.fitting_how_many_people} onChange={handleChangeHandler.bind(this, 'fitting_how_many_people')}>
                                <option value="">Select option</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11+">11+</option>
                            </select>
                        </div>
                        <div className="how-many-notice">
                            <span className="required">*</span> Less than 5 will be here at ACM's office
                        </div>
                        <div className="apparel-types">
                            What type of apparels? <span className="required">*</span>
                            <input className="scrubs-checkbox" type="checkbox" checked={props.fields.fitting_apparel_type_scrubs} onChange={handleChangeHandler.bind(this, 'fitting_apparel_type_scrubs')} /> Scrubs
                            <input type="checkbox" checked={props.fields.fitting_apparel_type_polos} onChange={handleChangeHandler.bind(this, 'fitting_apparel_type_polos')} /> Polos
                            <input type="checkbox" checked={props.fields.fitting_apparel_type_jackets} onChange={handleChangeHandler.bind(this, 'fitting_apparel_type_jackets')} /> Jackets
                            <input type="checkbox" checked={props.fields.fitting_apparel_type_other} onChange={handleChangeHandler.bind(this, 'fitting_apparel_type_other')} /> Other
                            <input type="text" value={props.fields.fitting_apparel_type_other_description} onChange={handleChangeHandler.bind(this, 'fitting_apparel_type_other_description')} />
                        </div>
                        <div className="styles">
                            What Style/Fit? <span className="required">*</span>
                            <input className="men-checkbox" type="checkbox" checked={props.fields.fitting_style_men} onChange={handleChangeHandler.bind(this, 'fitting_style_men')} /> Men
                            <input className="women-checkbox" type="checkbox" checked={props.fields.fitting_style_women} onChange={handleChangeHandler.bind(this, 'fitting_style_women')} /> Women
                            <input className="both-checkbox" type="checkbox" checked={props.fields.fitting_style_both} onChange={handleChangeHandler.bind(this, 'fitting_style_both')} /> Both
                        </div>
                    </div>
                    <hr />
                    <div className="fitting-location">
                        <h3>Your fitting location</h3>
                        <div className="column1">
                            <div className="address-field">
                                <div className="label">Address {fittingLocationRequiredAsterisk}:</div>
                                <input type="text" value={props.fields.fitting_address} onChange={handleChangeHandler.bind(this, 'fitting_address')} disabled={fittingLocationFieldsDisabled} />
                            </div>
                            <div className="city-field">
                                <div className="label">City {fittingLocationRequiredAsterisk}:</div>
                                <input type="text" value={props.fields.fitting_city} onChange={handleChangeHandler.bind(this, 'fitting_city')} disabled={fittingLocationFieldsDisabled} />
                            </div>
                            <div className="state-field">
                                <div className="label">State {fittingLocationRequiredAsterisk}:</div>
                                <input type="text" value={props.fields.fitting_state} onChange={handleChangeHandler.bind(this, 'fitting_state')} disabled={fittingLocationFieldsDisabled} />
                            </div>
                            <div className="zip-field">
                                <div className="label">Zip {fittingLocationRequiredAsterisk}:</div>
                                <input type="text" value={props.fields.fitting_zip} onChange={handleChangeHandler.bind(this, 'fitting_zip')} disabled={fittingLocationFieldsDisabled} />
                            </div>
                        </div>
                        <div className="column2">
                            <div className="department-field">
                                <div className="label">Department:</div>
                                <input type="text" value={props.fields.fitting_department} onChange={handleChangeHandler.bind(this, 'fitting_department')} disabled={fittingLocationFieldsDisabled} />
                            </div>
                            <div className="floor-field">
                                <div className="label">Floor:</div>
                                <input type="text" value={props.fields.fitting_floor} onChange={handleChangeHandler.bind(this, 'fitting_floor')} disabled={fittingLocationFieldsDisabled} />
                            </div>
                            <div className="building-field">
                                <div className="label">Building/Room number {fittingLocationRequiredAsterisk}:</div>
                                <input type="text" value={props.fields.fitting_building_number} onChange={handleChangeHandler.bind(this, 'fitting_building_number')} disabled={fittingLocationFieldsDisabled} />
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </Fragment>
        );
    }

    let uploadingFiles = null;
    if (props.isSending && props.files.length > 0) {
        uploadingFiles = <div><i className="fas fa-circle-notch fa-spin" /> Your files are uploading. It may take a few seconds depending on the size of the file.</div>;
    }

    let actions = [
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Close</button>,
        <button key="send-button" className="btn btn-light btn-sm action-button" onClick={sendHandler} disabled={props.isSending}>{label}</button>,
    ];
    return (
        <Dialog
            name="help-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 1000 }}
            bodyStyle={{ overflow: 'initial' }}
            className="help-dialog"
        >
            <div className="help-modal-container">
                <h2>Help Desk</h2>
                <div className="field">
                    <div className="label">Your Name <span className="required">*</span>:</div>
                    <input type="text" value={props.fields.name} onChange={handleChangeHandler.bind(this, 'name')} />
                </div>
                <div className="field">
                    <div className="label">Coupa PO#:</div>
                    <input type="text" value={props.fields.coupa_po} onChange={handleChangeHandler.bind(this, 'coupa_po')} />
                </div>
                <div className="field">
                    <div className="label">Email <span className="required">*</span>:</div>
                    <input type="text" value={props.fields.email} onChange={handleChangeHandler.bind(this, 'email')} />
                </div>
                <div className="field">
                    <div className="label">Order #:</div>
                    <input type="text" value={props.fields.order_id} onChange={handleChangeHandler.bind(this, 'order_id')} />
                </div>
                <div className="team-fields">
                    <div className="label">Your Team <span className="required">*</span>:</div>
                    <div className="utp-field">
                        <input type="radio" value="1" checked={teamType === 1} onChange={handleChangeHandler.bind(this, 'team_type')} />
                        UTPhysicians
                    </div>
                    <div className="uth-field">
                        <input type="radio" value="2" checked={teamType === 2} onChange={handleChangeHandler.bind(this, 'team_type')} />
                        UTHealth
                    </div>
                    <div className="personal-field">
                        <input type="radio" value="3" checked={teamType === 3} onChange={handleChangeHandler.bind(this, 'team_type')} />
                        Personal Purchase
                    </div>
                    <div className="other-field">
                        <input type="radio" value="4" checked={teamType === 4} onChange={handleChangeHandler.bind(this, 'team_type')} />
                        Other
                        <input type="text" value={props.fields.team_type_other} onChange={handleChangeHandler.bind(this, 'team_type_other')} />
                    </div>
                </div>
                <hr />
                <div className="help-fields">
                    <div className="label">Help With <span className="required">*</span>:</div>
                    <div className="printing-field">
                        <input type="checkbox" checked={props.fields.help_with_printing} onChange={handleChangeHandler.bind(this, 'help_with_printing')} />
                        Printing
                    </div>
                    <div className="promotions-field">
                        <input type="checkbox" checked={props.fields.help_with_promotional} onChange={handleChangeHandler.bind(this, 'help_with_promotional')} />
                        Promotional
                    </div>
                    <div className="apparel-field">
                        <input type="checkbox" checked={props.fields.help_with_apparel} onChange={handleChangeHandler.bind(this, 'help_with_apparel')} />
                        Apparel
                    </div>
                    <div className="apparel-field">
                        <input type="checkbox" checked={props.fields.help_with_fitting} onChange={handleChangeHandler.bind(this, 'help_with_fitting')} />
                        Fitting
                    </div>
                    <div className="other-field">
                        <input type="checkbox" checked={props.fields.help_with_other} onChange={handleChangeHandler.bind(this, 'help_with_other')} />
                        Other
                        <input type="text" checked={props.fields.help_with_other_description} onChange={handleChangeHandler.bind(this, 'help_with_other_description')} />
                    </div>
                </div>
                {fittingContainer}
                <div className="message-field">
                    <div className="label">Message to help desk <span className="required">*</span>: {fittingMessage}</div>
                    <textarea value={props.fields.message} onChange={handleChangeHandler.bind(this, 'message')} />
                </div>
                <div className="files-container">
                    <h3>
                        Attached Files
                        <div {...getRootProps({ className: 'dropzone-container' })}>
                            <input {...getInputProps()} />
                            <button>Browse</button>
                        </div>
                    </h3>
                    <table className="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th>Filename</th>
                                <th className="actions"></th>
                            </tr>
                        </thead>
                        <tbody>{renderFiles()}</tbody>
                    </table>
                    {uploadingFiles}
                </div>
            </div>
        </Dialog >
    );
});

HelpModal.propTypes = {

};

export default HelpModal;
